"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseText = require("./BaseText");

var _Theme = require("../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_BaseText.Text, {
    color: _Theme.darkColors.textTitle,
    style: {
      fontSize: 32,
      fontFamily: 'DIN Next LT Pro',
      fontWeight: 'bold'
    }
  }, children);
};

exports.SectionTitle = SectionTitle;